import store from '@/store'
import _ from 'lodash'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'

// 注文詳細画面モード
const INPUT_TYPE = Object.freeze(
  {
    TEXT: 1,              // テキストボックス
    MULTI_LINE_TEXT: 2,   // 複数行テキストボックス
    MULTI_TEXT: 3,        // 複数テキストボックス
    HTML: 4,              // htmlテキストボックス
    NUMBER: 5,            // 数値
    DATE: 6,              // 日付
    DATETTIME: 7,         // 日時
    SELECT: 8,            // 単一選択
    MULTI_SELECT: 9,      // 複数選択
    OBJECT_ARRAY: 10,     // オブジェクト配列
    CHECK_BOX: 11,        // チェックボックス
    MULTI_NUMBER: 12,     // 複数テキストボックス(数値)
    DATE_MILLI_SECONDS: 13,           // 日付（ミリ秒）
    DATETIME_MILLI_SECONDS: 14        // 日時（ミリ秒）
  }
)
export default {
  getCustomizeColumn (displayItem, customizeObj, attributePath, editableId, storePath, dataStorePath, { isChild = false, parentInstance = null, parentInstancePath = '', pathFromParent = '' } = {}) {
    const returnObject = {}
    returnObject.label = customizeObj.attributeName
    returnObject.properties = []

    let property = {}
    let index = -1
    property.validateAs = customizeObj.attributeName
    if (isChild) {
      property.path = customizeObj.attributeKey
      property.editableId = editableId
      if (displayItem[customizeObj.attributeKey] == null) {
        displayItem[customizeObj.attributeKey] = null
      }
      property.displayItem = displayItem
    } else {
      property.editableId = customizeObj.attributeKey
      index = (displayItem[attributePath] || []).findIndex((element) => element.attrId === customizeObj.attributeKey)
      if (index >= 0) {
        property.path = `${attributePath}.${index}.attrValue`
      } else {
        if (displayItem[attributePath] != null) {
          index = displayItem[attributePath].length
          displayItem[attributePath].push({ attrId: customizeObj.attributeKey, attrValue: null })
          property.path = `${attributePath}.${index}.attrValue`
        } else {
          return returnObject
        }
      }
    }

    property.validateRule = 'max:6000'
    if (customizeObj.isRequired) {
      property.validateRule += '|required'
    }

    switch (customizeObj.inputType) {
      case INPUT_TYPE.TEXT: // テキストボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.INPUT
        break
      case INPUT_TYPE.MULTI_LINE_TEXT: // 複数行テキストボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.INPUT_TEXT_AREA
        property.rows = 5
        property.class = 'multiLineTextBox'
        property.lineBreak = true
        break
      case INPUT_TYPE.MULTI_TEXT: // 複数テキストボックス（テキスト。内部データ：「"」括り。「,」区切り。）
      case INPUT_TYPE.MULTI_NUMBER: // 複数テキストボックス（テキスト。内部データ：「"」括り。「,」区切り。）
        // 最大文字数の対応
        // BASECELLのプロパティがメソッドの場合、実行した値になるように回収しておく
        property.elementType = ELEMENT_TYPE.CELL
        property.class = 'valueArray'
        property.editableId = isChild ? editableId : customizeObj.attributeKey
        property.properties = (displayItem, displayValue, editable) => {
          const property = []
          // カンマ区切りで配列分のCELLをを作成
          let values
          if (isChild) {
            values = displayValue || null
          } else {
            values = displayValue ? JSON.parse(displayValue) : null
          }
          if (values == null || values.length === 0) {
            values = ['']
            displayValue = JSON.stringify(values)
          }
          values.forEach((value, arrayIndex) => {
            // テキストボックス + 削除ボタンの形式でCELLのプロパティを作成
            let propertiesData = [{
              type: customizeObj.inputType === INPUT_TYPE.MULTI_TEXT ? 'String' : 'Number',
              elementType: customizeObj.inputType === INPUT_TYPE.MULTI_TEXT ? ELEMENT_TYPE.INPUT : ELEMENT_TYPE.INPUT_NUMBER,
              path: 'value',
              validateAs: customizeObj.attributeName,
              validateRule: 'max:6000',
              displayItem: { value },
              change: (event) => {
                if (isChild) {
                  const values = JSON.parse(parentInstance)
                  const val = _.get(values, pathFromParent) || ['']
                  if (val[arrayIndex] != null) {
                    val[arrayIndex] = event
                  }
                  _.set(values, pathFromParent, val)
                  store.dispatch({
                    type: 'set',
                    states: {
                      [parentInstancePath]: JSON.stringify(values)
                    }
                  })
                } else {
                  const values = JSON.parse(displayValue)
                  values[arrayIndex] = event
                  store.dispatch({
                    type: 'set',
                    states: {
                      [`${dataStorePath}/${attributePath}/${index}/attrValue`]: JSON.stringify(values)
                    }
                  })
                }
              },
              editableId: isChild ? editableId : customizeObj.attributeKey
            }]
            if (editable && values.length > 1) {
              propertiesData.push({
                type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'delBtn',
                icon: 'fas fa-times-circle', path: 'value',
                displayItem: { value },
                editableId: isChild ? editableId : customizeObj.attributeKey,
                click: (event, displayItem, inputValue) => {
                  if (isChild) {
                    const values = JSON.parse(parentInstance)
                    const val = _.get(values, pathFromParent) || ['']
                    if (val != null) {
                      val.splice(arrayIndex, 1)
                    }
                    _.set(values, pathFromParent, val)
                    store.dispatch({
                      type: 'set',
                      states: {
                        [parentInstancePath]: JSON.stringify(values)
                      }
                    })
                  } else {
                    const values = JSON.parse(displayValue)
                    values.splice(arrayIndex, 1)
                    store.dispatch({
                      type: 'set',
                      states: {
                        [`${dataStorePath}/${attributePath}/${index}/attrValue`]: JSON.stringify(values)
                      }
                    })
                  }
                }
              })
            }
            if (editable && (values.length === arrayIndex + 1)) {
              propertiesData.push({
                type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'addBtn',
                icon: 'fas fa-plus-circle', path: 'value',
                displayItem: { value },
                editableId: isChild ? editableId : customizeObj.attributeKey,
                size: 'small',
                click: (event, displayItem, inputValue) => {
                  if (isChild) {
                    const values = JSON.parse(parentInstance)
                    const val = _.get(values, pathFromParent) || ['']
                    val.push('')
                    _.set(values, pathFromParent, val)
                    store.dispatch({
                      type: 'set',
                      states: {
                        [parentInstancePath]: JSON.stringify(values)
                      }
                    })
                  } else {
                    const values = JSON.parse(displayValue)
                    values.push('')
                    store.dispatch({
                      type: 'set',
                      states: {
                        [`${dataStorePath}/${attributePath}/${index}/attrValue`]: JSON.stringify(values)
                      }
                    })
                  }
                }
              })
            }
            property.push({
              // カスタムタイプのセルを指定
              type: 'String', elementType: ELEMENT_TYPE.CELL,
              validateRule: `|customMaxLengthValue:${displayValue}`,
              properties: propertiesData,
              index: index,
              horizontal: true
            })
          })

          return property
        }
        break
      case INPUT_TYPE.HTML: // htmlテキストボックス（プレビュー付き）
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.INPUT_TEXT_AREA
        property.rows = 4
        property.class = 'multiLineTextBox'
        property.lineBreak = true
        returnObject.properties.push(property)

        // プレビューボタン
        property = {
          id: 'previewBtn',
          type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'previewBtn',
          icon: '', size: 'small', label: 'プレビュー',
          path: `${attributePath}.${index}.attrValue`,
          click: (event, displayItem, displayValue) => {
            store.dispatch({
              type: 'set',
              states: {
                [`${storePath}/htmlPreviewDialogVisible`]: true,
                [`${storePath}/htmlPreviewDialogContent`]: displayValue
              }
            })
          }
        }

        break
      case INPUT_TYPE.NUMBER: // 数値
        property.type = 'Number'
        property.elementType = ELEMENT_TYPE.INPUT_NUMBER
        break
      case INPUT_TYPE.DATE: // 日付
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATE
        property.dateFormat = 'YYYY/MM/DD'
        break
      case INPUT_TYPE.DATE_MILLI_SECONDS:            // 日付（ミリ秒）
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATE_MILLI_SECONDS
        property.dateFormat = 'YYYY/MM/DD'
        break
      case INPUT_TYPE.DATETTIME: // 日時
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATE_TIME
        property.dateFormat = 'YYYY/MM/DD HH:mm:ss'
        break
      case INPUT_TYPE.DATETIME_MILLI_SECONDS:        // 日時（ミリ秒）
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATETIME_MILLI_SECONDS
        property.dateFormat = 'YYYY/MM/DD HH:mm:ss'
        break
      case INPUT_TYPE.CHECK_BOX: // チェックボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.CHECK_BOX
        property.change = (displayItem) => {
          displayItem = Number(displayItem)
        }
        break
      case INPUT_TYPE.SELECT: // 単一選択
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.SELECT_BOX
        property.clearable = true
        property.codeName = customizeObj.optionKey
        property.selectCode = customizeObj.optionKey
        break
      case INPUT_TYPE.MULTI_SELECT: // 複数選択
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.SELECT_BOX
        property.multiple = true
        property.codeName = customizeObj.optionKey
        property.selectCode = customizeObj.optionKey
        break
      case INPUT_TYPE.OBJECT_ARRAY: // オブジェクト配列 1階層下のみ対応
        property.class = 'valueObjectArray'
        property.elementType = ELEMENT_TYPE.CELL
        property.editableId = isChild ? editableId : customizeObj.attributeKey

        const newEmptyChildObject = () => {
          const returnObject = {}
          customizeObj.childCustomizeProperty.forEach((child, childIndex) => {
            // 項目名
            returnObject[child.attributeKey] = null
          })
          return returnObject
        }
        if (displayItem[attributePath][index].attrValue == null) {
          displayItem[attributePath][index].attrValue = JSON.stringify([])
        }

        property.properties = (propDisplayItem, displayValue, editable) => {
          const childProperties = []
          let objectArrayValue = displayValue ? JSON.parse(displayValue) || [] : []

          // データ配列分
          objectArrayValue.forEach((objectValue, objectIndex) => {
            // 子オブジェクト分
            customizeObj.childCustomizeProperty.forEach((child, childIndex) => {
              const childCell = {
                elementType: ELEMENT_TYPE.CELL,
                horizontal: true,
                properties: []
              }

              // 項目名
              childCell.properties.push({
                type: 'string', displayItem: { title: `${child.attributeName}：` },
                path: 'title', class: 'itemLabel'
              })

              // 項目の値
              const newEmptyObject = this.getCustomizeColumn(objectValue, child,
                child.attributeKey, customizeObj.attributeKey,
                storePath, `${child.attributeKey}`,
                {
                  isChild: true,
                  parentInstancePath: `${dataStorePath}/${attributePath}/${index}/attrValue`,
                  parentInstance: displayValue,
                  pathFromParent: `${objectIndex}.${child.attributeKey}`
                })

              newEmptyObject.class = 'itemValue'
              newEmptyObject.change = (event) => {
                const values = JSON.parse(displayValue)
                values[objectIndex][child.attributeKey] = event
                store.dispatch({
                  type: 'set',
                  states: {
                    [`${dataStorePath}/${attributePath}/${index}/attrValue`]: JSON.stringify(values)
                  }
                })
              }
              newEmptyObject.validateRule = `customMaxLengthValue:${displayItem[attributePath][index].attrValue}`

              childCell.properties.push(newEmptyObject)

              childProperties.push(childCell)
            })

            const btnCell = {
              elementType: ELEMENT_TYPE.CELL,
              horizontal: true,
              properties: []
            }

            // 削除ボタン
            if (editable && objectArrayValue.length > 0) {
              btnCell.properties.push({
                type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'delBtn',
                icon: 'fas fa-times-circle', path: 'value',
                displayItem: { objectValue },
                editableId: isChild ? editableId : customizeObj.attributeKey,
                click: (event, displayItem, inputValue) => {
                  const values = JSON.parse(displayValue)
                  values.splice(objectIndex, 1)
                  store.dispatch({
                    type: 'set',
                    states: {
                      [`${dataStorePath}/${property.path}`]: JSON.stringify(values)
                    }
                  })
                }
              })
            }
            // 追加ボタン（最後であれば）
            if (editable && (objectArrayValue.length === objectIndex + 1)) {
              btnCell.properties.push({
                type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'addBtn',
                icon: 'fas fa-plus-circle', path: 'value',
                editableId: isChild ? editableId : customizeObj.attributeKey, size: 'small',
                click: (event, displayItem, inputValue) => {
                  const values = JSON.parse(displayValue)
                  values.push(newEmptyChildObject())
                  store.dispatch({
                    type: 'set',
                    states: {
                      [`${dataStorePath}/${property.path}`]: JSON.stringify(values)
                    }
                  })
                }
              })
            }
            if (btnCell.properties.length > 0) childProperties.push(btnCell)
          })
          // 追加ボタン（最後であれば）
          if (editable && objectArrayValue.length === 0) {
            const btnCell = {
              elementType: ELEMENT_TYPE.CELL,
              horizontal: true,
              properties: []
            }
            btnCell.properties.push({
              type: 'String', elementType: ELEMENT_TYPE.BUTTON, class: 'addBtn',
              icon: 'fas fa-plus-circle', path: 'value',
              editableId: isChild ? editableId : customizeObj.attributeKey, size: 'small',
              click: (event, displayItem, inputValue) => {
                const values = []
                values.push(newEmptyChildObject())
                store.dispatch({
                  type: 'set',
                  states: {
                    [`${dataStorePath}/${property.path}`]: JSON.stringify(values)
                  }
                })
              }
            })
            childProperties.push(btnCell)
          }

          return childProperties
        }
        break
    }

    if (isChild) {
      return property
    } else {
      returnObject.properties.push(property)
      return returnObject
    }
  },

  getCustomizeEmptyColumn () {
    const returnObject =
      {
        label: '　',
        properties: [{}]
      }

    return returnObject
  },
  getCustomizeListColumn (customizeObj, index) {
    const property = {
      label: customizeObj.attributeName,
      columnKey: 'attribute',
      path: `attributes.${index}.attrValue`
    }

    switch (customizeObj.inputType) {
      case INPUT_TYPE.TEXT: // テキストボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.INPUT
        break
      case INPUT_TYPE.MULTI_LINE_TEXT: // 複数行テキストボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.INPUT_TEXT_AREA
        property.rows = 5
        property.class = 'multiLineTextBox'
        property.lineBreak = true
        break
      case INPUT_TYPE.NUMBER: // 数値
        property.type = 'Number'
        property.elementType = ELEMENT_TYPE.INPUT_NUMBER
        break
      case INPUT_TYPE.DATE: // 日付
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATE
        property.dateFormat = 'YYYY/MM/DD'
        break
      case INPUT_TYPE.DATETTIME: // 日時
        property.type = 'Date'
        property.elementType = ELEMENT_TYPE.DATE_TIME
        property.dateFormat = 'YYYY/MM/DD HH:mm:ss'
        break
      case INPUT_TYPE.CHECK_BOX: // チェックボックス
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.CHECK_BOX
        break
      case INPUT_TYPE.SELECT: // 単一選択
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.SELECT_BOX
        property.codeName = customizeObj.optionKey
        property.selectCode = customizeObj.optionKey
        break
      case INPUT_TYPE.MULTI_SELECT: // 複数選択
        property.type = 'String'
        property.elementType = ELEMENT_TYPE.SELECT_BOX
        property.multiple = true
        property.codeName = customizeObj.optionKey
        property.selectCode = customizeObj.optionKey
        break
    }
    return property
  },
  getDefaultValue (customizeObj) {
    switch (customizeObj.inputType) {
      case INPUT_TYPE.TEXT: // テキストボックス
      case INPUT_TYPE.MULTI_LINE_TEXT: // 複数行テキストボックス
        return ''
      case INPUT_TYPE.NUMBER: // 数値
        return 0
      case INPUT_TYPE.DATE: // 日付
        return null
      case INPUT_TYPE.DATETTIME: // 日時
        return null
      case INPUT_TYPE.CHECK_BOX: // チェックボックス
        return 0
      case INPUT_TYPE.SELECT: // 単一選択
        return null
      case INPUT_TYPE.MULTI_SELECT: // 複数選択
        return []
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/product.js